import { useCallback, useRef } from "react";

import type { TopicMetadataType } from "api/api.types";
import { useLazyGetTopicMetadataQuery } from "api/topicsApi.slice";
import { useDispatch } from "common/utilities/react-redux";
import { unauthenticate } from "domains/authentication/actions";
import { activateModal } from "domains/modal/actions";
import { topicSlice } from "domains/topic/topic.slice";
import { getThrottledUnauthenticated } from "domains/user/sagas/unauthenticatedErrorSaga";

export const useFetchTopicMetadata = () => {
  const dispatch = useDispatch();
  const [fetchTopicMetadata] = useLazyGetTopicMetadataQuery();
  const fetchTopicMetadataRef = useRef<ReturnType<typeof fetchTopicMetadata> | undefined>(undefined);

  return useCallback(() => {
    fetchTopicMetadataRef.current?.abort();
    fetchTopicMetadataRef.current = fetchTopicMetadata(undefined, false);
    void fetchTopicMetadataRef.current.then((result) => {
      if (result.isError && "status" in result.error && result.error.status === 401 && !getThrottledUnauthenticated()) {
        dispatch(unauthenticate());
        dispatch(activateModal({ id: "Unauthenticated" }));
      }
      if (!result.isSuccess) return;
      dispatch(topicSlice.actions.setCustomTopicsCount(result.data.significant.types.reduce(sumCustomTopicCounts, 0)));
    });
  }, [dispatch, fetchTopicMetadata]);
};

const sumCustomTopicCounts = (accumulator: number, next: TopicMetadataType) =>
  next.type === "Custom Maps" ? accumulator + next.count : accumulator;
